import CashIcon from '@assets/icons/cash.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { CircledIcon } from '@/components/circled-icon';
import { createStyles } from '@/contexts/theme-context';
import { ListItem } from '@/components/list-item';

interface Props {
  onSelect: () => void;
}

export const RecordCashPaymentFooter: React.FC<Props> = ({ onSelect }) => {
  const [styles] = useStyles();

  return (
    <ListItem
      item={{ title: i18n.t('record_cash_payment'), value: '' }}
      listItemStyle={styles.listItem}
      onSelect={onSelect}
      renderLeftComponent={() => (
        <CircledIcon
          Icon={CashIcon}
          iconHeight={20}
          iconWidth={20}
          size="small"
        />
      )}
    />
  );
};

const useStyles = createStyles((theme) => ({
  listItem: {
    paddingHorizontal: theme.sk.spacing.spaceLarge,
  },
}));
